import React, { useState } from "react";
import {
  IconButton,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Tooltip,
} from "@mui/material";
import SecurityUpdateTwoToneIcon from "@mui/icons-material/SecurityUpdateTwoTone";
import axios from "axios";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";

const UpdateUserBtn = ({ user, onUserUpdate }) => {
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(user || {});
  const [loading, setLoading] = useState(false);

  const handleEdit = () => {
    setSelectedUser(user);
    setOpen(true);
  };

  const handleUpdate = async () => {
    if (!selectedUser.username || !selectedUser.email || !selectedUser.role) {
      toast.error("All fields are required!");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.put(
        `/api/v1/update-admin-users/${selectedUser.id}`,
        {
          role: selectedUser.role,
          username: selectedUser.username,
          email: selectedUser.email,
        }
      );

      if (response.status === 200) {
        toast.success("User updated successfully");
        if (onUserUpdate) {
          onUserUpdate(selectedUser);
        }
        setOpen(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating user");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip title="Update User">
        <IconButton
          onClick={handleEdit}
          sx={{
            color: "#2e7d32",
            "&:hover": {
              backgroundColor: "rgba(46, 125, 50, 0.1)",
            },
          }}
        >
          <SecurityUpdateTwoToneIcon />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ 
          bgcolor: "#f5f5f5",
          borderBottom: "1px solid #e0e0e0",
          fontWeight: "bold"
        }}>
          Update User
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}>
            <TextField
              fullWidth
              label="Username"
              variant="outlined"
              value={selectedUser?.username || ""}
              onChange={(e) => 
                setSelectedUser({ ...selectedUser, username: e.target.value })
              }
              sx={{ mb: 2 }}
            />

            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              value={selectedUser?.email || ""}
              onChange={(e) => 
                setSelectedUser({ ...selectedUser, email: e.target.value })
              }
              sx={{ mb: 2 }}
            />

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Role</InputLabel>
              <Select
                value={selectedUser?.role || ""}
                label="Role"
                onChange={(e) => 
                  setSelectedUser({ ...selectedUser, role: e.target.value })
                }
              >
                <MenuItem value="website-admin">Website Admin</MenuItem>
                <MenuItem value="super-admin">Super Admin</MenuItem>
                <MenuItem value="data-admin">Data Admin</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>

        <DialogActions sx={{ 
          p: 3,
          borderTop: "1px solid #e0e0e0"
        }}>
          <Button 
            onClick={() => setOpen(false)} 
            color="secondary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button 
            onClick={handleUpdate} 
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? "Updating..." : "Save Changes"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateUserBtn;